module.exports = __webpack_public_path__ + "img/enemy_3.b06db262.png";